import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonDataService } from '../Services/commonDataService';
import { Global } from '../Shared/global';
import { GenericReportCriteria } from '../Models/Common/GenericReportCriteria';
import { PaginationInfo } from '../Models/Common/PaginationInfo';
import { ReportResultType } from '../Shared/enum';
import { DBOperation } from '../Shared/enum';
import { AppContext } from '../Shared/common';

@Component({
  selector: 'pt-sessions',
  templateUrl: './ptsessions.component.html',
  styleUrls: ['./dashboard-widgets.css']
})
export class PtSessionsComponent implements OnInit {

  count: number = 0;
  reportCriteria: GenericReportCriteria = new GenericReportCriteria();

  constructor(private router: Router,
    private _service: CommonDataService,
    private appctx: AppContext) {
  }

  ngOnInit(): void {
    // initialize report criteria similar to ptAttendanceReportComponent
    if (!this.reportCriteria.Filters) {
      this.reportCriteria.Filters = [];
      this.reportCriteria.ResultType = ReportResultType.Grid;
      this.reportCriteria.FromDate = new Date();
      this.reportCriteria.ToDate = new Date();
      this.reportCriteria.OrgId = this.appctx.CurrentOrg?.OrgId;
      if (this.appctx.CurrentOrg && this.appctx.CurrentOrg.OrgUnits)
        this.reportCriteria.UnitId = this.appctx.CurrentOrg.OrgUnits.filter(u => u.IsSelected == true)[0]?.UnitId;
      this.reportCriteria.PaginationInfo = new PaginationInfo();
    }

    // Call backend to get PT attendance summary for today
    try {
      Global.onSubmitData(this.reportCriteria, DBOperation.create, this._service, (Global.BASE_USER_ENDPOINT() + Global.PtAttendanceEndpoint), this.reportGenerated, this);
    } catch (e) {
      Global.Log(e);
    }
  }

  reportGenerated(data: any, ctx: any) {
    try {
      if (!ctx) ctx = this;
      if (!data) {
        ctx.count = 0;
        return;
      }
      if (data.TotalCount != undefined) {
        ctx.count = data.TotalCount;
      } else if (data.ListItems) {
        ctx.count = data.ListItems.length;
      } else if (Array.isArray(data)) {
        ctx.count = data.length;
      } else {
        ctx.count = 0;
      }
    } catch (e) {
      Global.Log(e);
      ctx.count = 0;
    }
  }

  viewDetails() {
    this.router.navigate(['/core/ptattendance']);
  }

}
